 <section id="container" >
      <!--header start-->
     <app-header></app-header>
      <!--header end-->
      <!--sidebar start-->
      
      <!--sidebar end-->
      <!--main content start-->
      <section >
          <section class="wrapper">
              <!-- page start-->
              <div class="row">
                  <div class="col-lg-12">
                      <ul class="breadcrumb">
                          <li><a href="/"><i class="fa fa-home"></i> Home</a></li>
                          <li>Electronic signature on electronic comment</li>
                      </ul>
                  </div>
                  
              </div>
              <div class="row">
                  <div class="col-sm-12">
                 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                  </div>
                  
              </div>
              
              <!-- page end-->
          </section>
      </section>
      <!--main content end-->
      <!-- Right Slidebar start -->
     
      <!-- Right Slidebar end -->
      <!--footer start-->
      <app-footer></app-footer>
      <!--footer end-->
  </section>